module.exports = __webpack_public_path__ + "img/title_2@2x.c25cde45.png";